import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Credits = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M10.499 5.67188C10.943 5.67188 11.3036 6.03168 11.3037 6.47559C11.3037 6.91962 10.9431 7.28027 10.499 7.28027C10.0551 7.28012 9.69531 6.91953 9.69531 6.47559C9.69547 6.03178 10.0552 5.67203 10.499 5.67188Z"
      fill="#3063FD"
      stroke="white"
    />
    <path
      d="M8.95996 0.5C12.2959 0.500113 14.9999 3.20412 15 6.54004C15 9.38591 13.0308 11.7644 10.3877 12.4033C9.8629 8.65719 6.86147 5.65061 3.09473 5.11523C3.7325 2.47049 6.11294 0.5 8.95996 0.5Z"
      fill="#CC8600"
      stroke="white"
    />
    <path
      d="M13.48 8.48C13.23 5.31 10.69 2.77 7.52 2.52C7.35 2.51 7.17 2.5 7 2.5C3.41 2.5 0.5 5.41 0.5 9C0.5 12.59 3.41 15.5 7 15.5C10.59 15.5 13.5 12.59 13.5 9C13.5 8.83 13.49 8.65 13.48 8.48ZM7.88 9.88L7 11.5L6.12 9.88L4.5 9L6.12 8.12L7 6.5L7.88 8.12L9.5 9L7.88 9.88Z"
      fill="#FFA800"
      stroke="white"
    />
  </svg>
)

export default withDefaultStyles(Credits)
